import InformationDialog, {DialogButtonProps} from "./InformationDialog";
import {useTranslation} from "react-i18next";
import {CommonTranslKey} from "../CommonTranslKey";

export interface DialogProps {
    open: boolean;
    title: string;
    message: string;
    onConfirmation: () => void;
    onCancel: () => void;
}

export default function ConfirmationDialog(props: DialogProps) {
    const {open, title, message, onConfirmation, onCancel} = props;

    const {t} = useTranslation();

    const primaryProps: DialogButtonProps = { title: t(CommonTranslKey.CONFIRM), onClick: onConfirmation};
    const secondaryProps: DialogButtonProps = { title: t(CommonTranslKey.CANCEL), onClick: onCancel};

    return (
        <InformationDialog
            open={open}
            title={title}
            onClose={onCancel}
            primaryButton={primaryProps}
            secondaryButton={secondaryProps}
        >
            {message}
        </InformationDialog>
    );

}
